<template>
  <div class="d-flex align-items-center justify-content-center p-2" style="min-height:100vh;background: #003252;
background: linear-gradient(90deg, rgba(0, 50, 82, 1) 0%, rgba(0, 108, 128, 1) 100%);">
    <div class="p-4 shadow-lg" style="max-width:420px; width:100%;border-radius: 20px;background: transparent;backdrop-filter: blur(10px);">
      <div class="card-body">
        <h4 class="card-title mb-3 text-center text-light">Cameroon — Login</h4>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>

        <form @submit.prevent="onSubmit" novalidate class=" text-light">
          <div class="mb-3 ">
            <label class="form-label">Username</label>
            <input v-model.trim="username" type="text" class="form-control" required autocomplete="username">
          </div>
          <div class="mb-3">
            <label class="form-label">Password</label>
            <input v-model="password" type="password" class="form-control" required autocomplete="current-password">
          </div>
          <button :disabled="loading" class="btn btn-info w-100">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            Log in
          </button>
        </form>

     
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

const { login } = useAuth()
const router = useRouter()
const route = useRoute()

const username = ref('')
const password = ref('')
const error = ref('')
const loading = ref(false)
//const baseURL = 'http://localhost:9001/'

async function onSubmit() {
  error.value = ''
  loading.value = true
  try {
    await login(username.value, password.value)
    router.push(route.query.next || '/map')
  } catch (e) {
    error.value = e?.response?.data?.detail || e.message || 'Login failed'
  } finally {
    loading.value = false
  }
}
</script>
